
export const CoinsPage: React.FC = () => {
    return (
        <div>
            <h1>Coins Here!!</h1>
        </div>
    )
}
